import React from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router";

import style from "./JobsList.css";

const Row = ({ job }) => {
  const url = `/openings/?id=${job.id}`;
  let officeName = `${job.location.telecommuting ? "Remote" : job.location.city}, ${job.location.country}`;
  if (job.id === "15702c") {
    officeName = "All Markets"
  }

  return (
    <tr className={style.row}>
      <td className={style.title}>
        <Link className={style.link} to={url}>{job.title}</Link>
      </td>
      <td className={style.office}>{officeName}</td>
    </tr>
  );
};

Row.propTypes = {
  job: PropTypes.object.isRequired
};

const JobsList = ({ jobs }) => {
  if (!jobs.length) {
    return null;
  }

  return (
    <table className={style.jobsList}>
      <thead>
        <tr className={style.headerRow}>
          <th className={style.header}>Position</th>
          <th className={style.header}>Location</th>
        </tr>
      </thead>
      <tbody>
        {jobs.map((job) =>
          <Row key={`${job.id}-${job.location.country_code}`} job={job} />
        )}
      </tbody>
    </table>
  );
};

JobsList.propTypes = {
  jobs: PropTypes.array.isRequired
};

export default JobsList;



// WEBPACK FOOTER //
// ./component/TeamList/JobsList.js